import { svg } from "lit";

export function burgerMenuIcon() {
  return svg`   
   <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.665039 4.66504H11.3317M0.665039 0.665039H11.3317M0.665039 8.66504H11.3317" stroke="currentColor" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`;
}
